const quantityFormat = new Intl.NumberFormat('en-US');

export const formatQuantity = (value: number): string =>
  quantityFormat.format(value);

export const MAX_PRODUCT_QUANTITY = 9_999_999;
export const MIN_QUANTITY_MESSAGE = 'Minimum quantity is 1';
export const MAX_QUANTITY_MESSAGE = `Maximum quantity is ${formatQuantity(MAX_PRODUCT_QUANTITY)}`;
